import { render, staticRenderFns } from "./CustomerInsightsMaintenancePage.vue?vue&type=template&id=3505eab1&scoped=true"
import script from "./CustomerInsightsMaintenancePage.vue?vue&type=script&lang=js"
export * from "./CustomerInsightsMaintenancePage.vue?vue&type=script&lang=js"
import style0 from "./CustomerInsightsMaintenancePage.vue?vue&type=style&index=0&id=3505eab1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505eab1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3505eab1')) {
      api.createRecord('3505eab1', component.options)
    } else {
      api.reload('3505eab1', component.options)
    }
    module.hot.accept("./CustomerInsightsMaintenancePage.vue?vue&type=template&id=3505eab1&scoped=true", function () {
      api.rerender('3505eab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/CustomerInsightsMaintenancePage.vue"
export default component.exports